<template>
  <div :class="{ pcBg: pcFlag }">
    <div class="home" v-show="ishome">
      <div v-if="msg" id="msg" v-cloak>
        <template v-if="$route.params.id">
          {{ msg }}
        </template>
        <div v-else class="container" style="margin: 0 20px">
          <h1 style="font-size: 24px; margin-bottom: 16px">
            {{ $t('index.companyName') }}
          </h1>
          <ul style="font-size: 16px">
            <li>
              {{ $t('index.briefIntroduction') }}
            </li>
            <li style="margin-top: 10px">
              <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">{{ $t('index.beian') }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="appInfo.status === 'hidden' || appInfo.switch == 1" style="width: 80%; text-align: center; background-color: blue; word-wrap: break-word; word-break: break-all; min-height: 200rpx; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
        {{ appInfo.download_error ? appInfo.download_error : $t('index.yixiajia') }}
      </div>
      <div v-else-if="appInfo.uploadpwd && pwdTxt !== appInfo.uploadpwd" id="password" v-cloak>
        <div style="text-align: left">
          {{ $t('index.mima') }}：
          <input type="text" v-model="pwd" :placeholder="$t('index.mimaPlaceholder')" />
        </div>
        <div style="margin-top: 10px; text-align: left; padding-left: 41px; color: red">
          {{ pwdMsg ? $t('index.mimac') : '' }}
        </div>
        <button type="button" @click="tijiao" style="border: 1px solid #ccc; padding: 5px 10px; border-radius: 5px; margin-top: 10px; text-align: right">
          {{ $t('index.tijiao') }}
        </button>
      </div>

      <!-- 最新模版5 移动端样式 -->
      <div class="topbg" v-if="!pcFlag">
        <img class="ember3" :src="appInfo && appInfo.image" decoding="async" alt="" style="border-radius: 22.5%" :class="['icon118']" />
        <div style="font-size: 18px; color: #222; margin-top: 40px">
          {{ appInfo.ipa_name }}
        </div>
        <img :src="qrcode" alt="" style="width: 140px; height: 140px; margin-top: 69px" />

        <div style="width: 100%; display: flex; flex-direction: column; align-items: center; padding: 20px" v-if="appInfo.logmassage">
          <span style="font-size: 15px; color: #222">{{ $t('temp3.yyms') }}</span>
          <span style="margin-top: 10px; font-size: 13px; color: #666">{{ appInfo.logmassage }}</span>
        </div>
        <div @click="installApp(false)" style="background: #28caad; width: 140px; height: 40px; border-radius: 40px; line-height: 40px; text-align: center; color: #fff; margin-top: 44px">
          <span v-if="downloaded">
            {{ $t('index.back_desktop') }}
          </span>
          <span v-else>
            <b>{{ downloadFlag ? $t('index.installing') : $t('temp4.install') }}</b>
          </span>
        </div>
      </div>

      <div class="ember-view">
        <main class="selfclear is-apps-theme" v-cloak v-if="!msg && appInfo.status !== 'hidden' && appInfo.switch == 0 && pwdTxt === appInfo.uploadpwd">
          <input id="localnav-menustate" class="localnav-menustate" type="checkbox" />

          <div class="animation-wrapper is-visible" v-if="!pcFlag">
            <!-- 模板5 弹窗  :title="$t('index.resolveText')"-->
            <mu-dialog width="300" scrollable :open.sync="resolveShow">
              <div slot="title" style="font-size: 18px; font-weight: 700; color: #222; text-align: center">{{ $t('index.resolveText') }}</div>
              <div style="width: 100%; padding: 0px 5px; display: flex; flex-direction: column; align-items: center; max-height: 380px; overflow-y: scroll; font-size: 14px">
                <div style="width: 100%; text-align: center; margin-bottom: 10px">
                  <span style="color: #666">{{ $t('resolve.openSys') }}</span>
                  <span style="color: #154ec1">{{ $t('resolve.common') }}</span>
                </div>
                <img src="@/assets/template5/step1.jpg" style="width: 190px" alt="" />
                <div style="width: 100%; text-align: center; margin: 10px 0">
                  <span style="color: #666">{{ $t('resolve.click2') }}</span>
                  <span style="color: #154ec1">{{ $t('resolve.vpnDevice') }}</span>
                </div>
                <img src="@/assets/template5/step2.jpg" style="width: 190px" alt="" />
                <div style="width: 100%; text-align: center; margin: 10px 0">
                  <span style="color: #666">{{ $t('resolve.descFile') }}</span>
                </div>
                <img src="@/assets/template5/step3.jpg" style="width: 190px" alt="" />
                <div style="width: 100%; text-align: center; margin: 10px 0">
                  <span style="color: #666">{{ $t('resolve.belive') }}</span>
                </div>
                <img src="@/assets/template5/step4.jpg" style="width: 190px" alt="" />
                <div style="width: 100%; text-align: center; margin: 10px 0">
                  <span style="color: #666">{{ $t('resolve.beliveAgain') }}</span>
                </div>
                <img src="@/assets/template5/step5.jpg" style="width: 190px" alt="" />
                <div style="width: 100%; text-align: center; margin: 10px 0">
                  <span style="color: #666">{{ $t('resolve.complete') }}</span>
                </div>
              </div>
              <mu-button slot="actions" full-width color="#0052d9" textColor="#fff" @click="resolveShow = false">{{ $t('resolve.know') }}</mu-button>
            </mu-dialog>

            <!-- PC样式 -->
            <section class="l-content-width section section--bordered section--information" v-if="pcFlag">
              <div>
                <h2 class="section__headline">
                  <font style="vertical-align: inherit">
                    <font style="vertical-align: inherit">{{ $t('index.info') }}</font>
                  </font>
                </h2>
                <dl class="information-list information-list--app medium-columns l-row">
                  <div class="information-list__item l-column small-12 medium-6 large-4 small-valign-top">
                    <dt class="information-list__item__term medium-valign-top">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ $t('index.size') }}</font>
                      </font>
                    </dt>
                    <dd class="information-list__item__definition">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ appInfo.filesize }}</font>
                      </font>
                    </dd>
                  </div>

                  <div class="information-list__item l-column small-12 medium-6 large-4 small-valign-top">
                    <dt class="information-list__item__term medium-valign-top">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ $t('index.updateTime') }}</font>
                      </font>
                    </dt>
                    <dd class="information-list__item__definition">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ appInfo.updatetime }}</font>
                      </font>
                    </dd>
                  </div>
                  <div class="information-list__item l-column small-12 medium-6 large-4 small-valign-top">
                    <dt class="information-list__item__term medium-valign-top">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ $t('index.yuyan') }}</font>
                      </font>
                    </dt>
                    <dd class="we-truncate we-truncate--multi-line we-truncate--interactive information-list__item__definition">
                      <div data-clamp="" class="we-clamp">
                        <p dir="ltr" data-test-bidi="">
                          <font style="vertical-align: inherit">
                            <font style="vertical-align: inherit">{{ $t('index.yytext') }}</font>
                          </font>
                        </p>
                      </div>
                    </dd>
                  </div>
                  <div class="information-list__item l-column small-12 medium-6 large-4 small-valign-top">
                    <dt class="information-list__item__term medium-valign-top">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ $t('index.age') }}</font>
                      </font>
                    </dt>
                    <dd class="information-list__item__definition">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ $t('index.agetext') }}</font>
                      </font>
                    </dd>
                  </div>

                  <div class="information-list__item l-column small-12 medium-6 large-4 small-valign-top">
                    <dt class="information-list__item__term medium-valign-top">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">Copyright</font>
                      </font>
                    </dt>
                    <dd class="information-list__item__definition information-list__item__definition--copyright">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ appInfo.copyright }}</font>
                      </font>
                    </dd>
                  </div>
                  <div class="information-list__item l-column small-12 medium-6 large-4 small-valign-top">
                    <dt class="information-list__item__term medium-valign-top">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ $t('index.jiage') }}</font>
                      </font>
                    </dt>
                    <dd class="information-list__item__definition">
                      <font style="vertical-align: inherit">
                        <font style="vertical-align: inherit">{{ $t('index.free') }}</font>
                      </font>
                    </dd>
                  </div>
                </dl>
              </div>
            </section>
            <section class="l-content-width section section--bordered section--information" v-if="pcAdShow && pcFlag && pcAd.status === 'show' && whiteList.indexOf(appInfo.user_id) === -1 && appInfo.point <= 0">
              <div style="margin: 0 auto; max-width: 80%; display: flex; justify-content: center; position: relative; cursor: pointer" @click="jumpUrl(pcAd.url)">
                <img :src="pcAd.image.includes('https://') ? pcAd.image : pcAd.url + pcAd.image" alt="" srcset="" style="max-width: 100%; height: auto" />
                <div class="topright" @click.stop="pcAdShow = false">x</div>
              </div>
            </section>

            <!-- 移动端样式 -->
            <div class="appInfo" v-if="!pcFlag" style="width: 87.5% !important; margin: 0 auto; border-top: 1px solid #eee; margin-top: 30px">
              <span class="publicTitle" style="font-weight: 700">{{ $t('index.yy') }}{{ $t('index.info') }}</span>
              <div class="box">
                <ul>
                  <li>
                    <span>{{ $t('index.baoming') }}</span>
                    <p>{{ appInfo.identifier }}</p>
                  </li>
                  <li>
                    <span>{{ $t('index.version_no') }}</span>
                    <p>{{ appInfo.xlversion }}</p>
                  </li>
                  <li>
                    <span>{{ $t('index.size') }}</span>
                    <p>{{ appInfo.filesize }}</p>
                  </li>

                  <li>
                    <span>{{ $t('index.yuyan') }}</span>
                    <p>{{ $t('index.yytext') }}</p>
                  </li>
                  <!-- <li>
                    <span>{{ $t('index.age') }}</span>
                    <p>{{ $t('index.agetext') }}</p>
                  </li> -->
                  <!-- <li>
                    <span>{{ $t('index.jiage') }}</span>
                    <p>{{ $t('index.free') }}</p>
                  </li> -->
                  <li v-if="appInfo.support_url">
                    <span style="overflow: visible">{{ $t('index.support_url') }}</span>
                    <p>{{ appInfo.support_url }}</p>
                  </li>
                  <!-- <li v-if="appInfo.copyright">
                    <span>{{ $t('index.banquan') }}</span>
                    <p>{{ appInfo.copyright }}</p>
                  </li> -->
                </ul>
              </div>

              <!-- 应用截图 -->
              <div style="width: 100%; display: flex; flex-direction: column" v-if="appInfo.preview">
                <div style="padding: 0 30px 20px 0px; color: #999">{{ $t('index.yy') + $t('index.jt') }}</div>
                <div style="padding: 0 0px 0; width: 100%; overflow-x: scroll; overflow-y: hidden; display: flex; flex-wrap: nowrap; margin: 0px auto 0; scrollbar-width: none">
                  <img :src="item" style="width: 90%; margin-right: 15px; border-radius: 8px" alt="" v-for="(item, index) in appInfo.preview" :key="index" />
                </div>
              </div>
            </div>
            <div style="margin: 0 auto; max-width: 90%; display: flex; justify-content: center; position: relative; cursor: pointer" @click="jumpUrl(mobileAd.url)" v-if="mobileAdShow && !pcFlag && mobileAd.status === 'show' && whiteList.indexOf(appInfo.user_id) === -1 && appInfo.point <= 0">
              <img :src="mobileAd.image.includes('https://') ? mobileAd.image : mobileAd.url + mobileAd.image" alt="" srcset="" style="max-width: 100%; height: auto" />
              <div class="topright" @click.stop="mobileAdShow = false">x</div>
            </div>

            <!-- <div class="appInfo" v-if="appInfo && appInfo.isadvertisingisaon_status == 1">
              <a :href="appInfo && appInfo.isadvertisingisaon && appInfo.isadvertisingisaon.url">
                <img :src="appInfo && appInfo.isadvertisingisaon && appInfo.isadvertisingisaon.image" style="width: 100%" alt="" srcset="" />
              </a>
            </div> -->
          </div>
          <!-- pc端样式 -->
          <div v-else style="position: relative; top: 40px; left: 50%; transform: translate(-50%, 0); display: flex; flex-direction: column; align-items: center">
            <span style="font-weight: 700; margin-bottom: 40px">{{ $t('index.scan_download') }}</span>

            <img :src="appInfo && appInfo.image" style="width: 97px; height: 97px; border-radius: 20px" />
            <span style="margin: 30px auto">{{ appInfo.ipa_name }}</span>
            <div style="width: 140px; height: 140px; position: relative">
              <img :src="qrcode" alt="" style="width: 140px; height: 140px" />
              <img :src="appInfo.image" alt="" style="width: 26px; height: 26px; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); z-index: 99" />
            </div>
            <div style="width: 100%; display: flex; flex-direction: column; align-items: center; padding: 20px" v-if="appInfo.logmassage">
              <span style="font-size: 15px; color: #222">{{ $t('temp3.yyms') }}</span>
              <span style="margin-top: 10px; font-size: 13px; color: #666">{{ appInfo.logmassage }}</span>
            </div>
            <div style="width: 80%; display: flex; flex-direction: column; align-items: center" v-if="appInfo.preview">
              <div style="color: #333; margin-bottom: 15px; font-size: 15px">{{ $t('index.yy') + $t('index.jt') }}</div>
              <div style="padding: 0 0px 0; width: 100%; display: flex; flex-wrap: wrap; justify-content: center; margin: 0px auto 0; scrollbar-width: none;gap: 15px;">
                <img :src="item" style="width: 20%; border-radius: 8px" alt="" v-for="(item, index) in appInfo.preview" :key="index" />
              </div>
            </div>
            <!-- <div style="margin-top: 30px">{{ $t('index.statement') }}</div> -->
            <div style="width: 800px; margin: 80px auto; padding: 25px 0 0 0; border-top: 1px solid #eee">
              <div style="font-size: 20px; font-weight: 700">{{ $t('index.yy') }}{{ $t('index.info') }}</div>
              <div style="display: flex; flex-direction: column; width: 100%; padding: 15px 0 0 0">
                <div style="display: flex; justify-content: space-between">
                  <div style="flex: 1; margin-right: 80px; padding: 12px 0; border-bottom: 1px solid #eee; display: flex; justify-content: space-between">
                    <span>{{ $t('index.baoming') }}</span>
                    <span>{{ appInfo.identifier }}</span>
                  </div>
                  <div style="flex: 1; padding: 12px 0; border-bottom: 1px solid #eee; display: flex; justify-content: space-between">
                    <span>{{ $t('index.version_no') }}</span>
                    <span>{{ appInfo.xlversion }}</span>
                  </div>
                </div>

                <div style="display: flex; justify-content: space-between">
                  <div style="flex: 1; margin-right: 80px; padding: 12px 0; border-bottom: 1px solid #eee; display: flex; justify-content: space-between">
                    <span>{{ $t('index.size') }}</span>
                    <span>{{ appInfo.filesize }}</span>
                  </div>
                  <div style="flex: 1; padding: 12px 0; border-bottom: 1px solid #eee; display: flex; justify-content: space-between">
                    <span>{{ $t('index.updateTime') }}</span>
                    <span>{{ appInfo.updatetime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <div :class="{ footer: true, fixedBottom: pcFlag }" v-if="!msg && appInfo.status !== 'hidden' && appInfo.switch == 0 && pwdTxt === appInfo.uploadpwd">
        <p>
          {{ $t('index.disclaimer') }}：{{ $t('index.disclaimertext') }}
          <a href="javascript:;" style="margin-left: 5px" @click="report">
            <font style="vertical-align: inherit">
              <font style="vertical-align: inherit; color: #3485e2">{{ $t('index.djjb') }}</font>
            </font>
          </a>
        </p>
      </div>
    </div>
    <hongbao v-show="!ishome" @back="toggleBack" :appInfo="appInfo" :hongbaoAd="hongbaoAd" :whiteList="whiteList" :jumpObject="jumpObject" />
    <div class="modalClass" v-show="modalShow">
      <div style="margin-top: 25px">{{ $t('index.plaeseComputed') }}：</div>
      <div style="margin-top: 25px; width: 100%; text-align: center; font-size: 16px; color: #333">
        <span>{{ validateInfo.num1 }}</span>
        <span style="margin: 0 15px">+</span>
        <span>{{ validateInfo.num2 }}</span>
        <span style="margin-left: 15px">= ？</span>
      </div>
      <input v-model="result" type="number" :placeholder="$t('index.inputResult')" style="margin-top: 25px; height: 30px" />
      <div style="margin: 25px auto" class="confirm" @click="confirm">
        {{ $t('index.confirm') }}
      </div>
      <div class="close" @click="modalShow = false">×</div>
    </div>

    <mu-dialog :append-body="false" width="80%" :title="$t('index.ifTips')" :open.sync="tipsShow" style="border-radius: 15px">
      <img src="@/assets/step1.jpg" style="width: 100%" alt="" />
      <div style="width: 100%; display: flex; justify-content: center">
        <mu-button color="#549186" textColor="#fff" round @click="(tipsShow = false), (stepShow = true)">{{ $t('index.click_resolve') }}</mu-button>
      </div>
    </mu-dialog>
    <mu-dialog :append-body="false" width="80%" :open.sync="ios17tipShow" style="border-radius: 15px; padding: 15px">
      <div style="font-size: 13px; color: #333">{{ $t('index.ios17tip') }}</div>
      <div style="width: 100%; display: flex; justify-content: flex-end">
        <mu-button color="#549186" textColor="#fff" round @click="ios17tipShow = false">{{ $t('index.confirm') }}</mu-button>
      </div>
    </mu-dialog>
    <mu-dialog style="padding: 0" :append-body="false" :open.sync="stepShow" width="80%">
      <div style="width: 100%; display: flex; flex-direction: column">
        <mu-carousel hide-controls :cycle="false" style="height: 150px" hide-indicators @change="carouselChange">
          <mu-carousel-item style="height: 145px">
            <img src="@/assets/step2.jpg" style="width: 100%" alt="" />
          </mu-carousel-item>
          <mu-carousel-item style="height: 130px">
            <img src="@/assets/step3.jpg" style="width: 100%" alt="" />
          </mu-carousel-item>
          <mu-carousel-item style="height: 145px">
            <img src="@/assets/step4.jpg" style="width: 100%" alt="" />
          </mu-carousel-item>
        </mu-carousel>
        <div style="width: 100%; display: flex; flex-direction: column; color: #42a5f5; font-size: 12px; align-items: center; text-align: center; margin-top: 10px">
          <span>{{ $t('index.ccert_step') }}</span>
          <span style="margin-top: 8px" v-if="stepIndex == 0">{{ $t('index.step1') }}</span>
          <span style="margin-top: 8px" v-if="stepIndex == 1">{{ $t('index.step2') }}</span>
          <span style="margin-top: 8px" v-if="stepIndex == 2">{{ $t('index.step3') }}</span>
        </div>
        <div style="margin: 10px auto; display: flex">
          <div :class="{ dot: true, dotActive: stepIndex == 0 }"></div>
          <div :class="{ dot: true, dotActive: stepIndex == 1 }" style="margin: 0 15px"></div>
          <div :class="{ dot: true, dotActive: stepIndex == 2 }"></div>
        </div>
      </div>
    </mu-dialog>
    <report :baseUrl="baseUrl" :appInfo="appInfo" :appid="appInfo.id || 0" ref="report"></report>
  </div>
</template>

<script>
import { mixin } from '../../mixins/mixin.js';
import hongbao from './hongbao';
const today = new Date();
import report from '../report/report.vue';
export default {
  mixins: [mixin],
  components: {
    hongbao,
    report,
  },
  name: 'Home',
  data() {
    return {
      resolveShow: false,
      ios17tipShow: false,
      downloaded: false,
      home: 2,
      stepIndex: 0,
      tipsShow: false,
      stepShow: false,

      date: `${today.getMonth() + 1}-${today.getDate()}`,
    };
  },
  created() {
    this.getBroswerType();
  },
  mounted() {
    this.getQrCode();
  },
  computed: {
    mime() {
      return this.appInfo.mimetype;
    },
    cannotInstall() {
      if (this.mime == 'Android') {
        //包是安卓包
        return !this.androidFlag;
      } else {
        /* 包是IOS */
        return this.androidFlag;
      }
    },
    appNameParam() {
      return { appName: this.appInfo.ipa_name };
    },
  },
  methods: {
    carouselChange(index) {
      this.stepIndex = index;
    },
    getBroswerType() {
      var u = navigator.userAgent;
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      this.androidFlag = !isiOS;
    },
    goCert() {
      if (this.getIosVer() >= 17) {
        this.ios17tipShow = true;
        return;
      } else {
        window.open('https://hesus.gqkzzhuv.com/api/public/embedded.mobileprovision');
      }
    },
    getIosVer() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // 匹配iOS设备的userAgent
      var match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
      if (match) {
        // 返回版本号，格式为"主版本号.次版本号.修订号"（如果有的话）
        let version = `${match[1]}.${match[2]}${match[3] ? `.${match[3]}` : ''}`;
        return Number(version.split('.')[0]);
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .mu-dialog {
  border-radius: 12px !important;
}
.modalClass {
  background: #fff;
  position: fixed;
  top: 200px;
  left: 50%;
  transform: translate(-50%);
  width: 200px;
  // height: 300px;
  border-radius: 18px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.close {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #666;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
}
.confirm {
  // width: 68px;
  padding: 0 25px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  background-color: #1890ff;
  font-size: 14px;
  border-radius: 16px;
}
.ratingItem {
  font-size: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
  position: relative;
  &::after {
    content: '';
    display: block;
    height: 50px;
    border-right: 1px solid #eee;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0.32rem, -50%);
  }
}
.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #78829b;
}
.dotActive {
  background-color: #354dc8;
}
.pcBg {
  width: 100vw;
  height: 100vh;
  background-image: url('../../../assets/template5/topbg.png');
  background-size: auto 54px;
  background-repeat: repeat no-repeat;
  padding-top: 60px;
}
.topbg {
  width: 100vw;
  height: 100vh;
  background-image: url('../../../assets/template5/topbg.png');
  background-size: auto 54px;
  background-repeat: repeat no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.fixedBottom {
  position: fixed;
  bottom: 0;
  background-color: rgba(238, 238, 238, 0.8) !important;
}
@import url(@/assets/theme.less);
.icon118 {
  width: 118px;
  height: 118px;
}
</style>
